import React from 'react'
import AdministracionMenu from './administracion/administracionMenu'
export default function Menu() {
  return (
    <React.Fragment>
      <AdministracionMenu />
    </React.Fragment>
  )
}
